<template>
  <div class="container mt-5">
    <router-link class="float-right" to="/students">
      <i class="fas fa-chevron-left"></i> Regresar
    </router-link>

    <h2 class="text-light">
      <i class="fas fa-users"></i> Modificar Estudiante
    </h2>
    <form class="row" @submit.prevent="put()" v-if="student">
      <div class="col-md-4">
        <strong>Código:</strong>
        <input v-model="student.code" type="text" class="form-control mb-3" required />        
        <strong>Nombre:</strong>
        <input v-model="student.name" type="text" class="form-control mb-3" required />
        <strong>Apellido:</strong>
        <input v-model="student.lastName" type="text" class="form-control mb-3" required />
      </div>
      <div class="col-md-4">
        <strong>Token:</strong>
        <input v-model="student.token" type="text" class="form-control mb-3" required />
        <strong>Grupo:</strong>
        <select v-model="student.groupId" class="form-control mb-3" required>
          <option :value="group.id" v-for="group in groups" :key="group.id">{{ group.name }}</option>
        </select>
        <strong>Imagen:</strong>
        <input v-model="student.picture" type="text" class="form-control mb-3" />

        <button class="btn btn-dark" type="submit">
          Guardar
          <i class="fa fa-save"></i>
        </button>
        <router-link class="btn btn-dark ml-3" to="/students">
          Cancelar
          <i class="far fa-times-circle"></i>
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      groups: [],
      url: this.$store.state.url,
      schoolId: this.$store.state.schoolId,
      student: null
    };
  },
  mounted() {
    this.getStudent();
    this.getGroups();
  },
  methods: {
    async getStudent() {
      let req = await fetch(this.url + "student/" + this.id);
      this.student = await req.json();
    },
    async getGroups() {
      let req = await fetch(this.url + "groups/" + this.schoolId);
      this.groups = await req.json();
    },
    async put() {
      try {
        this.student.schoolId = this.schoolId;
        let data = {
          method: "put",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(this.student)
        };
        let req = await fetch(this.url + "student/" + this.id, data);
        if (req.ok) {
          this.$alert("Dato modificados correctamente", "Ok", "success").then(
            () => this.$router.push("/students")
          );
        }
      } catch (error) {
        this.$alert(error, "Ocurrió un error", "error");
      }
    }
  }
};
</script>

<style>
strong{color:#fff}
</style>